module.exports = ".display-text-newline {\n  /* white-space: pre; */\n}\n\n.successful-text {color:green;}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/change-password/change-password.component.css
// module id = ./src/app/manage-users/change-password/change-password.component.css
// module chunks = main